// src/utils/jwt.js
export function isJwtExpired(token) {
      if (!token) return true;
      try {
        const [, payload] = token.split('.');
        const decoded = JSON.parse(atob(payload));
        if (!decoded.exp) return true;
        // exp is in seconds, Date.now() is in ms
        return Date.now() >= decoded.exp * 1000;
      } catch (e) {
        return true; // treat as expired if any error
      }
    }